import axios from 'axios';

export interface AssignGreetsActionProps {
  greetIds: string[];
  assigneeId?: string;
}

export default async function assignGreetsAction({
  greetIds,
  assigneeId,
}: AssignGreetsActionProps) {
  return await axios('/api/v2/greets', {
    method: 'PATCH',
    data: {
      assignee_id: assigneeId,
      greets: greetIds,
    },
  }).then((res) => res.data);
}
